module.exports = __webpack_public_path__ + "media/images/admin/icons/message-circle-7796f8f5908baae73ff7967460a4f822.svg";